import React from 'react';
import PropTypes from 'prop-types';
import { usePayoutUpload, STEP } from './hooks/usePayoutUpload';
import { PayoutSelectStep } from './PayoutSelectStep';
import { PayoutReviewStep } from './PayoutReviewStep';
import { PayoutSummaryStep } from './PayoutSummaryStep';

// Orchestrates the payout upload flow: select promotion + CSV → review →
// submit → result summary. All logic lives in usePayoutUpload; each step is a
// presentational component.
export const PayoutUploadModal = ({ promotion, onClose }) => {
  const {
    step,
    activePromotions,
    selectedId,
    setSelectedId,
    file,
    fileInputRef,
    handleFileChange,
    isReading,
    review,
    result,
    isSubmitting,
    handleUpload,
    handleSubmit,
    goBack,
  } = usePayoutUpload({ promotion });

  if (step === STEP.SUMMARY && result) {
    return <PayoutSummaryStep result={result} onClose={onClose} />;
  }

  if (step === STEP.REVIEW && review) {
    return (
      <PayoutReviewStep
        review={review}
        onSubmit={handleSubmit}
        onBack={goBack}
        isSubmitting={isSubmitting}
      />
    );
  }

  return (
    <PayoutSelectStep
      activePromotions={activePromotions}
      selectedId={selectedId}
      setSelectedId={setSelectedId}
      file={file}
      fileInputRef={fileInputRef}
      onFileChange={handleFileChange}
      onUpload={handleUpload}
      isReading={isReading}
      onClose={onClose}
    />
  );
};

PayoutUploadModal.propTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    maxValueCents: PropTypes.number,
    isDisabled: PropTypes.bool,
  }),
  onClose: PropTypes.func.isRequired,
};

PayoutUploadModal.defaultProps = {
  promotion: null,
};
